module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcBAMAAACJyGLdAAAAJ1BMVEUAAAArbtMrbtMrbtMrbtMrbtMrbtP///8rbtPr8ftpmOBnl9/o7/rHflxSAAAAB3RSTlMA8a0mGbcoC4KDWwAAAHFJREFUGNNjAAJmxQ4QEDIAcQw7IEAYxNEIYQAB1yYQKeEA5rA0gsgOIIbRCA6yUR0Io0AcjZ3lIDC7CcSRmA7mVDaCOB3lENBBNw5LIxLHtQnB6egQQ+IIGSAbwIDCQXgBHE4rwZxT4HBKhHpbDD1sAXlfcFXkbARlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copy.png
// module id = 535
// module chunks = 8